import { approveUser, getAllUser } from "../../util/api";

export const FETCH_ALLUSER_REQUEST = 'app/adminPage/FETCH_ALLUSER_REQUEST';
export const FETCH_ALLUSER_SUCCESS = 'app/adminPage/FETCH_ALLUSER_SUCCESS';
export const FETCH_ALLUSER_ERROR = 'app/adminPage/FETCH_ALLUSER_ERROR';

export const APPROVE_LISTINGS_REQUEST = 'app/SettingPage/APPROVE_LISTINGS_REQUEST';
export const APPROVE_LISTINGS_SUCCESS = 'app/SettingPage/APPROVE_LISTINGS_SUCCESS';
export const APPROVE_LISTINGS_ERROR = 'app/SettingPage/APPROVE_LISTINGS_ERROR';

const initialState = {
  fetchInProgress: false,
  fetchSettingError: null,
  allUser: null
};


export default function adminPageReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ALLUSER_REQUEST:
      return { ...state, fetchInProgress: true, fetchSettingError: null };
    case FETCH_ALLUSER_SUCCESS: {

      return {
        ...state,
        fetchInProgress: false,
        allUser: payload,
      };
    
    }
    case FETCH_ALLUSER_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchSettingError: payload };

      case APPROVE_LISTINGS_ERROR:
        console.error(payload); // eslint-disable-line
        return { ...state, fetchInProgress: false, fetchSettingError: payload };
      case APPROVE_LISTINGS_REQUEST:
        return { ...state, fetchInProgress: true, users: [] };
      case APPROVE_LISTINGS_SUCCESS: {
        return {
          ...state,
          fetchInProgress: true,
          users: [],
        };
      }
    default:
      return state;
  }
}


const fetchAllUserRequest = () => ({ type: FETCH_ALLUSER_REQUEST });
const fetchAllUserSuccess = response => ({
  type: FETCH_ALLUSER_SUCCESS,
  payload: response.data.data,
});
const fetchAllUserError = e => ({
  type: FETCH_ALLUSER_ERROR,
  error: true,
  payload: e,
});


const approveUserRequest = () => ({ type: APPROVE_LISTINGS_REQUEST });
const approveUserRequestSuccess = response => ({
  type: APPROVE_LISTINGS_SUCCESS,
  payload: response,
});
const approveUserError = e => ({
  type: APPROVE_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export function fetchAllUser(state = initialState, params) {
  return (dispatch, getState, sdk) => {
    dispatch(fetchAllUserRequest());
    const data = {}
    return getAllUser(data).then(
      res => {
        dispatch(fetchAllUserSuccess(res))
      }
    )
      .catch(e => {
        console.log("error", e);
        return dispatch(fetchAllUserError(e))
      })
  }

}

export const handleApproveUser = (params) => (dispatch, getState, sdk) => {
  dispatch(approveUserRequest());
  return approveUser({ params })
    .then(res => {
      const userId = res?.data?.data?.id;
        dispatch(approveUserRequestSuccess());
        return true;
    })
    .catch(e => {
      dispatch(approveUserError(storableError(e)));
      throw e;
    });
};



export const loadData = ( params, search) => dispatch => {

  return dispatch(fetchAllUser())

};